
const phoneRegex = /^\d{10}$/;
const ssnRegex = /^\d{4}$/;
const noSpace = /^\S+$/;
const minThree = /([a-zA-Z].*?){3,}/;
const minOne = /([a-zA-Z].*?){1,}/;
const dateOfBirth = /^\d{2}\/\d{2}\/\d{4}$/;
const alphaNumericMinThree = /^[a-zA-Z0-9]{3,}$/;

export const screenpopRegex = {
    phoneRegex,
    ssnRegex,
    noSpace,
    minThree,
    minOne,
    dateOfBirth,
    alphaNumericMinThree
};